<template>
  <div class="searcher">
    <!-- Поле для ввода данных для поиска -->
    <div class="input-wrapper">
      <v-select
        class="v-select"
        v-model="selectedItem"
        :options="items"
        :label="colName"
        @search="handleSearch"
        @keydown.enter="searchOnServer"
        :placeholder="'Введите '+title"
      >
      <template v-slot:no-options="{ search, searching }">
        <div v-if="searching" class="create-block">
          <button 
            class="select-button" 
            @click="searchOnServer">Найти
          </button>
        </div>
      </template>
    </v-select>
    </div>

    <div v-if="selectedItem" class="data-block">
      <div v-for="(value, key) in selectedItem" :key="key" class="data-item">
        <span class="data-label">{{ key }}:</span>
        <span class="data-value">{{ value || 'Нет данных' }}</span>
      </div>
      <button class="select-button" @click="selectItem">Выбрать</button>
    </div>
    <button 
      v-else 
      class="select-button" 
      @click="createItem">Создать
    </button>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import  vSelect  from "vue-select";

export default {
  name: 'my-search-input',
  props:["colName",'model','title'],
  components:{vSelect},
  setup(props,{emit}) {
    const store = useStore();

    const searchTerm = ref('');
    const selectedItem = ref(null);
    const searchNotResult = ref(false)
    const filteredCars = ref([]);

    const items = computed(()=> store.state.apiStorage.search[props.model])
    const searchList = computed(()=> store.state.apiStorage.options.company)
    
    const resetFields = ()=>{
      searchTerm.value = ''
      selectedItem.value = null
      searchNotResult.value = false
      filteredCars.value = []
    }

    const handleSearch = (value) => {
      searchTerm.value = value.trim();  
    };

    const searchOnServer = async () => {
      const result = await store.dispatch('apiStorage/searchOnServer',
        {model:props.model,params:{[props.colName]:searchTerm.value}});
      if(!result){
        searchNotResult.value = true
      }
    };

    const selectItem = ()=>{
      emit('selectItem',selectedItem.value)
      resetFields()
    }

    const createItem = ()=>{
      emit('createItem',true)
    }

    return {
      items,
      searchNotResult,
      searchTerm,
      handleSearch,
      searchOnServer,
      selectedItem,
      selectItem,
      createItem,
    };
  },
};
</script>


<style scoped>

.searcher {
  display: flex;
  padding: 5px;
  justify-content: space-around;
}

.v-select{
  font-size: 12px;
  width: 450px;
}

.input-wrapper {
  flex: 1; /* Use flex: 1 to make the v-select occupy available space */
}

.data-block {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
}

/* Стили для каждого элемента данных в блоке */
.data-item {
  margin-bottom: 5px;
}

/* Стили для метки элемента данных */
.data-label {
  font-weight: bold;
  margin-right: 5px;
}

.select-button {
  padding: 8px 16px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

/* Стили для кнопки "Выбрать" при наведении */
.select-button:hover {
  background-color: #0056b3;
}

.create-button{

}

.create-block{
  display: flex;
  align-content: center;
  justify-content: center;
  flex: 1;
}
</style>
